import { Circle, Flex, Icon, Text } from '@chakra-ui/react';
import { Check } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IStepsProps {
  currentStep: number;
}

export const Steps = ({ currentStep }: IStepsProps) => {
  const { t } = useTranslation('checkout/common');
  const normalizedCurrentStep = currentStep - 1;

  const STEPS = [
    { title: t('plans') },
    { title: t('data') },
    { title: t('payment') },
    { title: t('summary') },
  ];

  const styleProps = (index: number) => {
    if (index < normalizedCurrentStep) {
      return {
        bg: 'sustainability-green.900',
        color: 'sustainability-green.900',
        fontWeight: 'bold',
      };
    }

    if (index === normalizedCurrentStep) {
      return {
        bg: 'business.900',
        color: 'black',
        fontWeight: 'bold',
      };
    }

    return {
      bg: 'brand.200',
      color: 'neutral.600',
      fontWeight: 'normal',
    };
  };

  return (
    <Flex
      align="center"
      justify="space-between"
      w={{ lg: 'full' }}
      gap={4}
      maxW={900}
      overflowX="auto"
    >
      {STEPS.map((step, index) => (
        <React.Fragment key={index}>
          <Flex
            flexDir={{ base: 'column', lg: 'row' }}
            alignItems="center"
            gap={2.5}
          >
            <Circle
              size="40px"
              bg={styleProps(index).bg}
              color={'white'}
              fontWeight="bold"
            >
              {index < normalizedCurrentStep ? <Icon as={Check} /> : index + 1}
            </Circle>
            <Text
              fontWeight={styleProps(index).fontWeight}
              color={styleProps(index).color}
            >
              {step.title}
            </Text>
          </Flex>
        </React.Fragment>
      ))}
    </Flex>
  );
};
